<app-page-header [title]="currentTitle"></app-page-header>

<ul class="nav nav-pills mb-3">
    <li class="nav-item">
        <a class="nav-link" [routerLink]="['user-access']" routerLinkActive="active">User Access</a>
    </li>
</ul>

<router-outlet></router-outlet>
